import { Component, Input, OnInit, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ParametriStampa } from 'src/app/models/parametri-stampa';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ParametriStampaService } from 'src/app/shared/services/parametri-stampa.service';
import * as FileSaver from 'file-saver';
import notify from 'devextreme/ui/notify';
import {
  DxButtonComponent,
  DxFileUploaderComponent,
  DxLoadPanelComponent,
  DxTextAreaComponent
} from 'devextreme-angular';

@Component({
  selector: 'app-form-parametri-stampa',
  templateUrl: './form-parametri-stampa.component.html',
  styleUrls: ['./form-parametri-stampa.component.scss'],
  imports: [
    DxButtonComponent, 
    DxFileUploaderComponent, 
    DxTextAreaComponent,
    DxLoadPanelComponent
  ],
  standalone: true,
})
export class FormParametriStampaComponent implements OnInit {
  private paramateriStampaS = inject(ParametriStampaService);
  private nS = inject(NavigatorService);
  private sanitizer = inject(DomSanitizer);

  @Input() tipoparstampa: string;

  parametriStampa: ParametriStampa;
  files: any;
  strHeaderBase64: string;
  currentHeader: SafeResourceUrl;
  strFirmaBase64: string;
  currentFirma: SafeResourceUrl;
  headerVisibile: boolean = true;
  firmaVisibile: boolean = true;

  visibleLoadPanel = false;

  ngOnInit() {
    this.getParametri();
  }

  getParametri() {
    this.parametriStampa = new ParametriStampa();
    if (this.tipoparstampa == 'DPI') {
      this.paramateriStampaS.get('DPI').subscribe((dati) => {
        if (dati != null) {
          console.log('Parametri di stampa:' + dati);
          this.parametriStampa = dati;
          this.currentHeader = this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image;base64,' + this.parametriStampa.headerBase64,
          );
          if (this.parametriStampa.headerBase64 == null) {
            this.headerVisibile = false;
          }

          this.currentFirma = this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image;base64,' + this.parametriStampa.firmaTimbroBase64,
          );
          if (this.parametriStampa.firmaTimbroBase64 == null) {
            this.firmaVisibile = false;
          }

          this.parametriStampa.logoFileName = null;
          this.parametriStampa.headerFileName = null;
          this.parametriStampa.firmaTimbroFileName = null;

          this.parametriStampa.logoBase64 = null;
          this.parametriStampa.headerBase64 = null;
          this.parametriStampa.firmaTimbroBase64 = null;
        }
      });
    } else if (this.tipoparstampa == 'DOTAZIONI') {
      this.paramateriStampaS.get('DOTAZIONI').subscribe((dati) => {
        if (dati != null) {
          console.log('Parametri di stampa:' + dati);
          this.parametriStampa = dati;
          this.currentHeader = this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image;base64,' + this.parametriStampa.headerBase64,
          );
          if (this.parametriStampa.headerBase64 == null) {
            this.headerVisibile = false;
          }

          this.currentFirma = this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image;base64,' + this.parametriStampa.firmaTimbroBase64,
          );
          if (this.parametriStampa.firmaTimbroBase64 == null) {
            this.firmaVisibile = false;
          }

          this.parametriStampa.logoFileName = null;
          this.parametriStampa.headerFileName = null;
          this.parametriStampa.firmaTimbroFileName = null;

          this.parametriStampa.logoBase64 = null;
          this.parametriStampa.headerBase64 = null;
          this.parametriStampa.firmaTimbroBase64 = null;
        }
      });
    }
  }

  //Button "Salva"
  SalvaParametri(e) {
    const result = e.validationGroup.validate();
    if (result.isValid) {
      this.visibleLoadPanel = true;
      if (this.tipoparstampa == 'DPI') {
        this.paramateriStampaS
          .insert(this.parametriStampa, 'DPI')
          .subscribe({
            next: () => {
              this.visibleLoadPanel = false;
            //if (dati.id> 0){
              notify({
                message: 'Parametri di stampa DPI salvati correttamente',
                width: 300,
                shading: true,
                type: 'success',
              });
            },
            error: (error) => {
              this.visibleLoadPanel = false;
              if (error?.status == 500 && error?.error?.title) {
                notify(error?.error?.title, 'warning');
              } else {
                notify('Errore salvataggio parametri DPI', 'warning');
              }
            },
            // }
          });
      } else if (this.tipoparstampa == 'DOTAZIONI') {
        this.paramateriStampaS
          .insert(this.parametriStampa, 'DOTAZIONI')
          .subscribe({
            next: () => {
            //if (dati.id> 0){
              notify({
                message: 'Parametri di stampa DOTAZIONI salvati correttamente',
                width: 300,
                shading: true,
                type: 'success',
              });
            },
            error: (error) => {
              this.visibleLoadPanel = false;
              if (error?.status == 500 && error?.error?.title) {
                notify(error?.error?.title, 'warning');
              } else {
                notify('Errore salvataggio parametri DOTAZIONI', 'warning');
              }
            },
            // }
          });
      }
    } else {
      notify('Compilare i campi obbligatori', 'warning', 2000);
    }
  }

  onKeyDown(args) {
    if (args.event.keyCode == 13) {
      args.event.stopPropagation();
    }
  }

  getHeader(event) {
    // this.files = event.target.files;
    // const reader = new FileReader();
    // reader.onload = this._handleReaderLoaded_header.bind(this);
    // reader.readAsArrayBuffer(this.files[0]);
    // this.parametriStampa.headerFileName = this.files[0].name;

    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = this._handleReaderLoaded_header.bind(this);
    reader.readAsDataURL(file);
    
  }

  _handleReaderLoaded_header(readerEvt) {
    const dataUrl = readerEvt.target.result as string;
    this.strHeaderBase64 = dataUrl.split(',')[1]; // Converting binary string data.
    this.parametriStampa.headerBase64 = this.strHeaderBase64;

    this.currentHeader = this.sanitizer.bypassSecurityTrustResourceUrl(
      'data:image;base64,' + this.parametriStampa.headerBase64,
    );
  }

  getFirma(event) {
    // this.files = event.target.files;
    // const reader = new FileReader();
    // reader.onload = this._handleReaderLoaded_firma.bind(this);
    // reader.readAsArrayBuffer(this.files[0]);
    // this.parametriStampa.firmaTimbroFileName = this.files[0].name;
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = this._handleReaderLoaded_firma.bind(this);

    reader.readAsDataURL(file);
  }

  _handleReaderLoaded_firma(readerEvt) {
    const dataUrl = readerEvt.target.result as string;
    this.strFirmaBase64 = dataUrl.split(',')[1]; // Converting binary string data.
    this.parametriStampa.firmaTimbroBase64 = this.strFirmaBase64;

    this.currentFirma = this.sanitizer.bypassSecurityTrustResourceUrl(
      'data:image;base64,' + this.parametriStampa.firmaTimbroBase64,
    );
  }

  //Button "Test Stampa Report"
  testStampaReport() {
    this.visibleLoadPanel = true;
    this.paramateriStampaS.stampaprova('DPI').subscribe({
      next: (scarica) => {
        this.visibleLoadPanel = false;
        FileSaver.saveAs(scarica, 'stampa-prova.pdf');
      },
      error: (error) => {
        this.visibleLoadPanel = false;
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore test stampa report', 'warning');
        }
      },
    });
    this.paramateriStampaS.stampaprova('DPI');
  }
}
